"use client";

import React from "react";
import type { IconProps } from "@/components/icons/icons-utils/icon-props";
import { useIconLayout } from "@/components/icons/icons-utils/use-icon-layout";

// MARK: Group
/**
 * Group icon — add SVG markup inside the root `<svg>`.
 *
 * **Reuse scope:** Project-wide — `@/components/icons` registry.
 */
export const Group: React.FC<IconProps> = (props) => {
    const { resolved_width, resolved_height, effective_stroke_width, className, svg_style, rest } = useIconLayout(props);

    return (
        <svg
            viewBox="0 0 24 24"
            width={resolved_width}
            height={resolved_height}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            style={svg_style}
            strokeWidth={effective_stroke_width}
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden
            {...rest}
        >
            <path d="M8 6L20 6" ></path>
            <path d="M4 6.01L4.01 5.99889" ></path>
            <path d="M4 12.01L4.01 11.9989" ></path>
            <path d="M4 18.01L4.01 17.9989" ></path>
            <path d="M8 12L20 12" ></path>
            <path d="M8 18L20 18" ></path>
        </svg>
    );
};

Group.displayName = "Group";
